import React, { Component } from 'react';
import ReactPaginate from 'react-paginate';
import '../Pagination.css';
import '../Alumnos/AlumnoForm.css';
import '../Alumnos/MDAlumnos.css';
import * as constantClass from '../fileWithConstants';
import { MD_PAGE_SIZE, fetchAndApplyIndexPage } from '../../services/mdServerIndex';
import { MdTableHeaderCell } from '../common/MdRowActions';
import {
  AUDITORIA_ENTIDAD_FILTER_OPTIONS,
  getEntidadLabel,
} from './auditoriaEntityLabels';

const ACCIONES = ['Alta', 'Baja', 'Modificacion', 'Generacion'];

const ACCION_LABELS = {
  Alta: 'Alta',
  Baja: 'Baja',
  Modificacion: 'Modificación',
  Generacion: 'Generación',
};

function renderFechaHora(value) {
  if (!value) {
    return '';
  }
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return String(value);
  }
  return (
    <span className="md-auditoria__fecha">
      <span className="md-auditoria__fecha-dia">{date.toLocaleDateString('es-AR')}</span>
      <span className="md-auditoria__fecha-hora">{date.toLocaleTimeString('es-AR')}</span>
    </span>
  );
}

function formatJsonPreview(value) {
  if (!value) {
    return '—';
  }
  try {
    const parsed = JSON.parse(value);
    return JSON.stringify(parsed, null, 2);
  } catch {
    return value;
  }
}

function getAccionBadgeClass(accion) {
  switch (accion) {
    case 'Alta':
      return 'md-page__badge md-page__badge--success';
    case 'Baja':
      return 'md-page__badge md-page__badge--danger';
    case 'Modificacion':
      return 'md-page__badge md-page__badge--warning';
    case 'Generacion':
      return 'md-page__badge md-page__badge--info';
    default:
      return 'md-page__badge md-page__badge--neutral';
  }
}

function getAccionLabel(accion) {
  return ACCION_LABELS[accion] || accion || '—';
}

export class MDAuditoria extends Component {
  static displayName = MDAuditoria.name;

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      paginationData: [],
      perPage: MD_PAGE_SIZE,
      totalCount: 0,
      pageCount: 0,
      offset: 0,
      currentPage: 0,
      searched: false,
      showErrorMessage: false,
      errorMessage: '',
      filters: {
        usuarioNombre: '',
        entidad: '',
        accion: '',
        fechaDesde: '',
        fechaHasta: '',
      },
    };
  }

  componentDidMount() {
    constantClass.canAccess('WWAuditoria');
  }

  handleFilterChange = (e) => {
    const { name, value } = e.target;
    this.setState((prev) => ({
      filters: {
        ...prev.filters,
        [name]: value,
      },
      showErrorMessage: false,
      errorMessage: '',
    }));
  };

  handleBuscar = async (e) => {
    if (e) e.preventDefault();
    this.setState({
      loading: true,
      searched: true,
      showErrorMessage: false,
      errorMessage: '',
    });
    await this.populateData(0, '');
  };

  handlePageClick = (e) => {
    this.populateData(e.selected, '');
  };

  buildExtraParams() {
    const { filters } = this.state;
    return {
      usuarioNombre: filters.usuarioNombre,
      entidad: filters.entidad,
      accion: filters.accion,
      fechaDesde: filters.fechaDesde,
      fechaHasta: filters.fechaHasta,
    };
  }

  renderTable(items) {
    return (
      <div className="md-page__table-card md-auditoria__table-wrap">
        <table className="md-page__table md-auditoria__table" aria-labelledby="auditoria-title">
          <colgroup>
            <col className="md-auditoria__col-fecha" />
            <col className="md-auditoria__col-usuario" />
            <col className="md-auditoria__col-accion" />
            <col className="md-auditoria__col-entidad" />
            <col className="md-auditoria__col-detalle" />
          </colgroup>
          <thead>
            <tr>
              <MdTableHeaderCell cellType="date" className="md-auditoria__cell md-auditoria__cell--fecha">Fecha</MdTableHeaderCell>
              <MdTableHeaderCell cellType="text" className="md-auditoria__cell md-auditoria__cell--usuario">Usuario</MdTableHeaderCell>
              <MdTableHeaderCell cellType="text" className="md-auditoria__cell md-auditoria__cell--accion md-page__table__badge-cell">Acción</MdTableHeaderCell>
              <MdTableHeaderCell cellType="text" className="md-auditoria__cell md-auditoria__cell--entidad">Entidad</MdTableHeaderCell>
              <MdTableHeaderCell cellType="text">Detalle</MdTableHeaderCell>
            </tr>
          </thead>
          <tbody>
            {items.map((item) => (
              <tr key={item.auditoriaCambioId}>
                <td className="md-auditoria__cell md-auditoria__cell--fecha md-page__table__cell--date">{renderFechaHora(item.auditoriaCambioFecha)}</td>
                <td className="md-auditoria__cell md-auditoria__cell--usuario md-page__table__cell--text">{item.usuarioNombre || '—'}</td>
                <td className="md-auditoria__cell md-auditoria__cell--accion md-page__table__cell--text">
                  <span className={getAccionBadgeClass(item.auditoriaCambioAccion)}>
                    {getAccionLabel(item.auditoriaCambioAccion)}
                  </span>
                </td>
                <td className="md-auditoria__cell md-auditoria__cell--entidad md-page__table__cell--text">
                  {getEntidadLabel(item.auditoriaCambioEntidad)}
                </td>
                <td className="md-auditoria__cell md-auditoria__cell--detalle md-page__table__cell--text">
                  <details className="md-auditoria__detalle">
                    <summary>Ver cambios</summary>
                    {item.auditoriaCambioValoresAnteriores ? (
                      <div className="md-auditoria__detalle-block">
                        <strong>Antes:</strong>
                        <pre>{formatJsonPreview(item.auditoriaCambioValoresAnteriores)}</pre>
                      </div>
                    ) : null}
                    {item.auditoriaCambioValoresNuevos ? (
                      <div className="md-auditoria__detalle-block">
                        <strong>Después:</strong>
                        <pre>{formatJsonPreview(item.auditoriaCambioValoresNuevos)}</pre>
                      </div>
                    ) : null}
                    {!item.auditoriaCambioValoresAnteriores && !item.auditoriaCambioValoresNuevos ? (
                      <span>—</span>
                    ) : null}
                  </details>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  render() {
    const {
      loading,
      searched,
      paginationData,
      pageCount,
      offset,
      perPage,
      filters,
      showErrorMessage,
      errorMessage,
    } = this.state;

    const hasResults = !loading && searched && paginationData.length > 0;
    const noResults = !loading && searched && paginationData.length === 0;

    return (
      <div className="md-page md-form-page consultar-auditoria">
        <h1 id="auditoria-title" className="md-page__title">Auditoría de cambios del sistema</h1>
        <p className="md-form-page__subtitle">
          Consulta de solo lectura. Registra altas, bajas, modificaciones y generaciones en entidades críticas.
        </p>

        <div className="md-page__feedback" aria-live="polite" role="status">
          {showErrorMessage ? (
            <div className="md-page__error" role="alert">
              {errorMessage}
            </div>
          ) : null}
        </div>

        <div className="md-form-page__card md-auditoria__filters-card">
          <form className="md-form-page__form md-auditoria__filters-form" onSubmit={this.handleBuscar} noValidate>
            <div className="md-auditoria__filters-bar">
              <div className="md-form-page__field">
                <label className="md-form-page__label" htmlFor="aud-usuario">
                  Usuario
                </label>
                <input
                  id="aud-usuario"
                  className="md-form-page__input"
                  type="text"
                  name="usuarioNombre"
                  placeholder="Usuario"
                  value={filters.usuarioNombre}
                  onChange={this.handleFilterChange}
                  disabled={loading}
                />
              </div>

              <div className="md-form-page__field">
                <label className="md-form-page__label" htmlFor="aud-entidad">
                  Entidad
                </label>
                <select
                  id="aud-entidad"
                  className="md-form-page__input"
                  name="entidad"
                  value={filters.entidad}
                  onChange={this.handleFilterChange}
                  disabled={loading}
                >
                  <option value="">Todas</option>
                  {AUDITORIA_ENTIDAD_FILTER_OPTIONS.map((entidad) => (
                    <option key={entidad.value} value={entidad.value}>{entidad.label}</option>
                  ))}
                </select>
              </div>

              <div className="md-form-page__field">
                <label className="md-form-page__label" htmlFor="aud-accion">
                  Acción
                </label>
                <select
                  id="aud-accion"
                  className="md-form-page__input"
                  name="accion"
                  value={filters.accion}
                  onChange={this.handleFilterChange}
                  disabled={loading}
                >
                  <option value="">Todas</option>
                  {ACCIONES.map((accion) => (
                    <option key={accion} value={accion}>{getAccionLabel(accion)}</option>
                  ))}
                </select>
              </div>

              <div className="md-form-page__field md-auditoria__field--date">
                <label className="md-form-page__label" htmlFor="aud-fecha-desde">
                  Desde
                </label>
                <input
                  id="aud-fecha-desde"
                  className="md-form-page__input"
                  type="date"
                  name="fechaDesde"
                  value={filters.fechaDesde}
                  onChange={this.handleFilterChange}
                  disabled={loading}
                />
              </div>

              <div className="md-form-page__field md-auditoria__field--date">
                <label className="md-form-page__label" htmlFor="aud-fecha-hasta">
                  Hasta
                </label>
                <input
                  id="aud-fecha-hasta"
                  className="md-form-page__input"
                  type="date"
                  name="fechaHasta"
                  value={filters.fechaHasta}
                  onChange={this.handleFilterChange}
                  disabled={loading}
                />
              </div>

              <button
                type="submit"
                className="md-form-page__btn md-form-page__btn--primary md-auditoria__search-btn"
                disabled={loading}
              >
                Buscar
              </button>
            </div>
          </form>
        </div>

        {loading ? (
          <p className="md-page__loading"><em>Cargando resultados...</em></p>
        ) : null}

        {noResults ? (
          <p className="md-page__empty"><em>No hay resultados</em></p>
        ) : null}

        {hasResults ? this.renderTable(paginationData) : null}

        {hasResults && pageCount > 0 ? (
          <div className="md-page__pagination">
            <ReactPaginate
              previousLabel="Anterior"
              nextLabel="Siguiente"
              breakLabel="..."
              breakClassName="break-me"
              pageCount={pageCount}
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
              forcePage={Math.floor(offset / perPage)}
              onPageChange={this.handlePageClick}
              containerClassName="pagination"
              subContainerClassName="pages pagination"
              activeClassName="active"
            />
          </div>
        ) : null}
      </div>
    );
  }

  async populateData(page = 0, search = '') {
    await fetchAndApplyIndexPage(this, {
      indexUrl: 'api/aud/Index',
      page,
      search,
      perPage: this.state.perPage,
      extraParams: this.buildExtraParams(),
    });
  }
}
